import React from "react";
// import icon from "../../_resources/img/sidebar/devices.png"
import {NavItem} from "../NavItem";
import { Monitor } from 'lucide-react';
//import PropTypes from 'prop-types';


export function DevicesLink({ isCollapsed }) { //{defaultParams}) {

    return <NavItem 
    redirectUrl={"/devices"} 
    Icon={Monitor} 
    label={"Devices"}
    isCollapsed={isCollapsed}
    />

    // /**
    //  * The table is updated from the url parameters,
    //  and by default the sorted field should be specified in the url
    //  @return {string} param string as '&firs_param=value&second_param=value
    //  */
    // const getInitialUrlWithDefaultParams = () => {
    //     return Object.keys(defaultParams).length ?
    //         Object.entries(defaultParams).reduce((acc, param)=>{
    //             return acc + `&${param[0]}=${param[1]}`
    //         },''): ''
    // }

    // return <NavItem
    //     icon={icon}
    //     redirectUrl={`/devices?pageTitle=Devices${getInitialUrlWithDefaultParams()}`}
    //     text={"Devices"}/>
}

// DevicesLink.defaultProps = {
//     defaultParams: {}
// };

// DevicesLink.propTypes = {
//     defaultParams: PropTypes.object
// };
